import { render, staticRenderFns } from "./nuevo-propietario.vue?vue&type=template&id=591b702c&"
import script from "./nuevo-propietario.vue?vue&type=script&lang=js&"
export * from "./nuevo-propietario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports